import { Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import StyledDataGrid from "../../../../components/StyledDataGrid";
import { ProtectionLevelOrder } from "../../../../utils/constants";
import ProtectionLevel from "../../steps/components/ProtectionLevel";

export default function TechniqueStepsTable({ steps, onRowClick }) {
  const colors = useColors();

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
      renderCell: (params) => {
        return <Typography variant="body2">#{params.value}</Typography>;
      },
    },
    {
      field: "name",
      headerName: "Attack Step",
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography
            variant="body2"
            style={{
              textAlign: "start",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {params.value}
          </Typography>
        );
      },
    },
    {
      field: "protection_level",
      headerName: "Status",
      width: 180,
      renderCell: (params) => {
        return <ProtectionLevel level={params.value} />;
      },
      sortComparator: (v1, v2) => {
        const value1 = ProtectionLevelOrder[v1] || 0;
        const value2 = ProtectionLevelOrder[v2] || 0;
        return value1 - value2;
      },
    },
  ];

  const rows = steps.flatMap((step) => {
    const baseRow = {
      id: step.step_id,
      name: step.name,
      protection_level: step.protection_level,
    };

    return [baseRow];
  });

  const [sortModel, setSortModel] = useState([
    {
      field: "protection_level",
      sort: "asc",
    },
  ]);

  return (
    <StyledDataGrid
      sx={{
        cursor: "pointer",
      }}
      columns={columns}
      rows={rows}
      pageSizeOptionsOverride={[10, 20]}
      getRowClassName={(params) => (params.row.isSubRow ? "sub-row" : "")}
      onCellClick={(params, event) => {
        if (params.field !== "expand") {
          event.stopPropagation();
          if (!params.row.isSubRow) {
            const step_id = params.row.id;
            onRowClick(step_id);
          }
        }
      }}
      sx={{
        "& .MuiDataGrid-cell:first-of-type, & .MuiDataGrid-columnHeader:first-of-type":
          {
            paddingLeft: "20px",
          },
      }}
      sortModel={sortModel}
      onSortModelChange={(model) => setSortModel(model)}
    />
  );
}
